import { useTranslation } from 'react-i18next';

import { config } from '../../config';
import { getAssetAccessLevel } from '../../shared/helpers/assetHelpers';
import { Paywall } from '../Paywall/Paywall';
import { SimpleSubscribeButton } from '../SimpleSubscribeButton/SimpleSubscribeButton';
import { isHermesApp } from '../../utils/device';

import { getSubscriptionPrice } from './getSubscriptionPrice';

import type { ButtonProps } from '../Button/Button';
import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';
import type { FC } from 'react';

interface SubscribeButtonProps {
  asset: SvpAssetAdditional;
  size?: ButtonProps['size'];
}

const SubscribeButton: FC<SubscribeButtonProps> = ({
  asset,
  size = 'large',
}) => {
  const { t } = useTranslation();

  if (isHermesApp) {
    return null;
  }

  const access = getAssetAccessLevel(asset);
  const price = getSubscriptionPrice();
  const label = t(
    access === 'sport' ? 'Subscribe to sport' : 'Subscribe to watch'
  );

  const fallback = (
    <SimpleSubscribeButton
      asset={asset}
      label={label}
      price={price}
      access={access}
      size={size}
    />
  );

  if (config.provider === 'ab') {
    return fallback;
  }

  return (
    <Paywall
      asset={asset}
      buttonLabel={label}
      buttonSize={size}
      fallback={fallback}
      access={access}
    />
  );
};

export { SubscribeButton };
